/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

/**
 * Created by andrea on 2017-06-19.
 */

export class Venue {

  constructor(public id: string,
              public name: string,
              public city: string,
              public address: string = null,
              public province: string = null,
              public country: string = null,
              public postalCode: string = null,
              public latitude: number = null,
              public longitude: number = null,
              public website: string = null) {

  }

  static fromSnapshot(snap: any) {
    return Venue._fromSnapshot(snap.key, snap.val());
  }

  private static _fromSnapshot(key: string, {address, city, country, latitude, longitude, name, postalCode, province, website}) {
    return new Venue(key, name, city, address, province, country, postalCode, latitude, longitude, website);
  }
}



// WEBPACK FOOTER //
// ./src/models/Venue.ts